import {
  Box,
  Button,
  FormControlLabel,
  makeStyles,
  Switch
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { editSwitchMediaType } from 'src/store/modules/switchButton';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ImageIcon from '@material-ui/icons/Image';
import VideoIcon from '@material-ui/icons/Videocam';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '16px',
    paddingRight: '26px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F5F5F5'
  },
  mediaTypeText: {
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem'
  }
}));
export default function SwitchMediaType() {
  const switchMediaType = useSelector(
    (state: RootState) => state.switchButton.switchMediaType
  );
  useEffect(() => {
    setPosition(switchMediaType);
  }, [switchMediaType]);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [position, setPosition] = useState(switchMediaType);

  return (
    <div>
      <Box className={classes.wrapper}>
        <span className={classes.mediaTypeText}>MEDIA TYPE</span>
        <ToggleButtonGroup
          value={position}
          exclusive
          onChange={(e, newValue) => {
            if (newValue && newValue !== position) {
              setPosition(newValue);
              dispatch(editSwitchMediaType(newValue));
            }
          }}
        >
          <ToggleButton value="image">
            <ImageIcon /> Image
          </ToggleButton>
          <ToggleButton value="video">
            <VideoIcon /> Video
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </div>
  );
}
